import React, { useState, useEffect, useContext } from 'react';
// contexts
import { SwineContext } from 'shared/contexts';
import LoadingHolder from 'components/LoadingHolder';
// service
import { getMedicationDetails } from '../../FlockList/service';
import AddMedication from './AddMedication';
import MedicationDetails from './MedicationDetails';

export default function EditMedication(props) {
  const swineContext = useContext(SwineContext);
  const { selectedMedicationId, medicationResponse } = swineContext;
  const {
    setSelectedMedicationId,
    setMedicationResponse,
    setSuccess,
    setFavoriteCandidate,
  } = swineContext.actions;

  const [loadingMedication, setLoadingMedication] = useState(false);
  const [medication, setMedication] = useState(null);

  async function fetchMedication(id) {
    setLoadingMedication(true);
    try {
      const response = await getMedicationDetails(id);
      setMedication(response);
    } catch (e) {
      console.error('Error on getMedicationDetails', e);
    }
    setLoadingMedication(false);
  }

  useEffect(() => {
    if (selectedMedicationId) {
      fetchMedication(selectedMedicationId);
    }
  }, [selectedMedicationId]);

  useEffect(() => {
    if (medicationResponse === null) {
      setSuccess(false);
    }
  }, [medicationResponse, setSuccess]);

  useEffect(() => {
    if (props.removed) {
      props.goTo('medicationSummary');
    }
  }, [props, props.removed]);

  return (
    <>
      <LoadingHolder isLoading={loadingMedication} />

      {props.isEditing ? (
        <AddMedication
          {...props}
          isEditing={props.isEditing}
          medication={medication}
          setSelectedMedicationId={setSelectedMedicationId}
          loadingMedication={loadingMedication}
          medicationResponse={medicationResponse}
          setMedicationResponse={setMedicationResponse}
          setSuccess={setSuccess}
          setFavoriteCandidate={setFavoriteCandidate}
        />
      ) : (
        <MedicationDetails
          medication={medication}
          goTo={props.goTo}
          setDisplayExcludeModal={props.setDisplayExcludeModal}
        />
      )}
    </>
  );
}
